export default __webpack_public_path__ + "static/media/altar-bg-final-4k.436c58d5.jpg";